module.exports = __webpack_public_path__ + "assets/img/logo-background-dark.76438672.svg";